import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('ModalHeader', slot);
}

export const modalHeaderClasses = generateUtilityClasses('ModalHeader', [
  'root',
  'content',
  'title',
  'description',
  'closeIcon',
]);
